import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { CertificateTaxonomyFieldsComponent } from './components/certificate-taxonomy-fields/certificate-taxonomy-fields.component';
import { AddCertificateDialogComponent } from './components/dialogs/add-certificate-dialog/add-certificate-dialog.component';
import { AddCertificateUserProfileDialogComponent } from './components/dialogs/add-certificate-user-profile-dialog/add-certificate-user-profile-dialog.component';
import { CertificateDateFilterDialogComponent } from './components/dialogs/certificate-date-filter-dialog/certificate-date-filter-dialog.component';
import { CertificationsDialogComponent } from './components/dialogs/certifications-dialog/certifications-dialog.component';
import { CertificationsFilterDialogComponent } from './components/dialogs/certifications-filter-dialog/certifications-filter-dialog.component';
import { EditCertificateDialogComponent } from './components/dialogs/edit-certificate-dialog/edit-certificate-dialog.component';
import { InternalCertificationTemplateDialogComponent } from './components/dialogs/internal-certification-template-dialog/internal-certification-template-dialog.component';
import { EditCertificateMobilePageComponent } from './components/edit-certificate-mobile-page/edit-certificate-mobile-page.component';
import { AdminCertificationWriteGuard } from './guards/admin-certification-write.guard';
import { CertificateExpirationColorPipe } from './pipes/certification-expiration-color.pipe';
import { CertificateExpirationDisabledPipe } from './pipes/certification-expiration-disabled.pipe';
import { CertificateExpirationIconPipe } from './pipes/certification-expiration-icon.pipe';
import { CertificateRecordResolver } from './services/certificate-record.resolver';
import { CertificationApiService } from './services/certification.api-service';
import { CertificationService } from './services/certification.service';

@NgModule({
    imports: [
        MaxBrainSharedModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatIconModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatInputModule,
        MatDatepickerModule,
        MatStepperModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        MatCheckboxModule,
        MatChipsModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatSlideToggleModule,
        MatTooltipModule,
    ],
    providers: [
        CertificationService,
        CertificationApiService,
        CertificateRecordResolver,
        CertificateExpirationColorPipe,
        CertificateExpirationIconPipe,
        CertificateExpirationDisabledPipe,
        AdminCertificationWriteGuard,
    ],
    declarations: [
        CertificateExpirationColorPipe,
        CertificateExpirationIconPipe,
        CertificateExpirationDisabledPipe,
        CertificateTaxonomyFieldsComponent,
        CertificateDateFilterDialogComponent,
        AddCertificateDialogComponent,
        EditCertificateDialogComponent,
        CertificationsFilterDialogComponent,
        CertificationsDialogComponent,
        InternalCertificationTemplateDialogComponent,
        AddCertificateUserProfileDialogComponent,
        EditCertificateMobilePageComponent,
    ],
    exports: [
        CertificateExpirationColorPipe,
        CertificateExpirationIconPipe,
        CertificateExpirationDisabledPipe,
        CertificateTaxonomyFieldsComponent,
        AddCertificateDialogComponent,
        EditCertificateDialogComponent,
        CertificationsFilterDialogComponent,
        CertificationsDialogComponent,
        InternalCertificationTemplateDialogComponent,
        AddCertificateUserProfileDialogComponent,
        EditCertificateMobilePageComponent,
    ],
})
export class CertificationModule {
    static forRoot(): ModuleWithProviders<CertificationModule> {
        return {
            ngModule: CertificationModule,
            providers: [CertificationApiService],
        };
    }
}
